import type { PortalUser } from '@/services/api/types';

/**
 * Best-effort display name for the signed-in user. The Portal fills different
 * fields depending on how the account was created, so fall back through
 * full name -> e-mail -> null (caller decides what to render instead).
 */
export function displayName(user: PortalUser | null): string | null {
  if (!user) {
    return null;
  }
  const full = [user.firstname, user.lastname].filter((part) => part && part.trim()).join(' ');
  if (full) {
    return full;
  }
  return user.eMail?.trim() || null;
}

/** Best-effort organization name for the authenticated user, or `null` if unknown. */
export function organizationName(user: PortalUser | null): string | null {
  if (!user) {
    return null;
  }

  return user.orgDisplayName?.trim() || user.orgName?.trim() || null;
}
